import type { CookieOptions } from "types";

export function hasCookie(cookieName: string): boolean {
  return document.cookie
    .split(";")
    .some((item) => item.trim().startsWith(`${cookieName}=`));
}

export function getCookie(cookieName: string): string[] {
  return document.cookie
    .split(";")
    .map((item) => {
      const cookie = item.trim();
      return cookie.startsWith(`${cookieName}=`) ? cookie : undefined;
    })
    .filter((cookie): cookie is string => cookie !== undefined);
}

export function getCookieValue(cookieName: string): string | undefined {
  const cookie = getCookie(cookieName)[0];
  return cookie?.replace(/^(.*?)=/, "");
}

export function setCookie(
  cookieName: string,
  cookieValue: string,
  options: CookieOptions,
): void {
  document.cookie = `${cookieName}=${cookieValue}; expires=${options.expires}; SameSite=${options.sameSite}; ${options.secure}`;
}
